/**
 * EthereumStakingOrderStatus
 */
enum OrderStatusEnum {
  /**
   *  The order has been placed but payment has not been authorized. The order is not ready for shipment.
   */
  WAITING_FOR_PAYMENT = 'waiting',
  PAYMENT_FAILED = 'payFailed',
  /**
   * Payment has been authorized and order is ready for shipment, but no items in the order have been shipped.
   */
  PENDING = 'pending',
  /**
   * One or more validators in the order have been shipped.
   */
  ACTIVE = 'active',
  SLASHED = 'slashed',
  /**
   * all validators exit
   */
  EXIT = 'exit',
  EXITING = 'exiting',
}
export { OrderStatusEnum };
